import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || menuOpen ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/205390b4-ccff-46e5-9dd3-9143091b163d.png"
              alt="栄伸株式会社"
              className={`h-8 md:h-10 w-auto object-contain transition-all duration-300 ${
                isScrolled || menuOpen ? '' : 'brightness-0 invert'
              }`}
            />
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center space-x-8">
            {[
              { id: 'home', label: 'ホーム' },
              { id: 'about', label: '企業情報' },
              { id: 'services', label: '事業内容' },
              { id: 'restaurants', label: '花木流味噌' },
              { id: 'consulting', label: 'コンサルティング' },
              { id: 'contact', label: 'お問い合わせ' },
            ].map((item, i, arr) => (
              <>
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
                  }`}
                >
                  {item.label}
                </button>
                {i < arr.length - 1 && (
                  <div key={`sep-${item.id}`} className={`w-px h-4 ${isScrolled ? 'bg-gray-300' : 'bg-white/30'}`}></div>
                )}
              </>
            ))}
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block bg-teal-700 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-teal-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            無料相談予約
          </button>

          {/* Hamburger */}
          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              isScrolled || menuOpen ? 'text-slate-800' : 'text-white'
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニュー"
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-1">
          {[
            { id: 'home', label: 'ホーム' },
            { id: 'about', label: '企業情報' },
            { id: 'services', label: '事業内容' },
            { id: 'restaurants', label: '花木流味噌 五反野店' },
            { id: 'consulting', label: 'コンサルティング' },
            { id: 'contact', label: 'お問い合わせ' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 rounded-lg transition-colors cursor-pointer font-medium"
            >
              {item.label}
            </button>
          ))}
          <div className="pt-2">
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-teal-700 text-white py-3 rounded-full text-sm font-medium hover:bg-teal-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              無料相談予約
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
